import React, { useEffect, useState, useMemo } from "react";
import { Oval } from "react-loader-spinner";
import { showSnackbar } from "../../comopnents/snackbar";
import { getVerificationList } from "../../services/Tools";
import "./styles/Productlist.css";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const VerificationList = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await getVerificationList();
      const data = Array.isArray(res) ? res : res?.data || [];
      setLogs(data);
    } catch (err) {
      console.error("Verification list error:", err);
      showSnackbar("error", "Failed to load verification logs");
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const filtered = useMemo(() => {
    let data = [...logs];
    if (searchTerm.trim()) {
      const search = searchTerm.toLowerCase().trim();
      data = data.filter(
        (r) =>
          (r.mobileno || "").toLowerCase().includes(search) ||
          (r.hologramno || "").toLowerCase().includes(search) ||
          String(r.userid || "")
            .toLowerCase()
            .includes(search),
      );
    }
    data.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
    return data;
  }, [logs, searchTerm]);

  const totalItems = filtered.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (page - 1) * pageSize;
  const paginatedData = filtered.slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  const exportCSV = () => {
    if (filtered.length === 0) return;

    const headers = [
      "S.No",
      "Mobile Number",
      "Date",
      "Hologram Number",
      "Product ID",
      "Message",
      "Reward",
      "Verification Type",
      "Model Number",
    ];

    const rows = filtered.map((r, i) => [
      i + 1,
      r.mobileno ?? "",
      r.date ?? "",
      r.hologramno ?? "",
      r.productid ?? "",
      `"${(r.msg || "").replace(/"/g, '""')}"`,
      r.reward ?? "",
      r.type ?? "",
      r.modelno ?? "",
    ]);

    const csv = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `VerificationLogs_${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;

    link.click();
    URL.revokeObjectURL(link.href);
  };

  const getBadgeClass = (type) => {
    if (!type) return "pending";
    const lower = type.toLowerCase();
    if (lower.includes("success")) return "success";
    if (lower.includes("fail")) return "failed";
    return "pending";
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Oval
          height={60}
          width={60}
          color="#6366f1"
          secondaryColor="#e2e8f0"
          strokeWidth={4}
        />
      </div>
    );
  }

  return (
    <div className="product-page">
      <div className="product-header">
        <div className="product-title">Verification Logs</div>
        <div className="filter-group">
          <button
            className="export-btn"
            onClick={exportCSV}
            disabled={filtered.length === 0}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Export CSV
          </button>
        </div>
      </div>

      <div className="search-container">
        <div className="search-box-wrapper">
          <div className="search-box">
            <svg
              className="search-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Search by Mobile No, Hologram, or User ID"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="clear-search"
                onClick={() => setSearchTerm("")}
              >
                ✕
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>S.NO</th>
              <th>MOBILE NUMBER</th>
              <th>DATE</th>
              <th>HOLOGRAM NUMBER</th>
              {/* <th>PRODUCT ID</th> */}
              <th>MESSAGE</th>
              <th>REWARD</th>
              <th>VERIFICATION TYPE</th>
              <th>MODEL NUMBER</th>
              <th>Warranty</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((r, idx) => (
                <tr key={r.id || startIndex + idx}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{r.mobileno ?? "-"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {r.date
                      ? new Date(r.date).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                      : "-"}
                  </td>
                  <td>{r.hologramno ?? "-"}</td>
                  {/* <td>{r.productid ?? "-"}</td> */}
                  <td className="message-cell">
                    <span className="message-text" title={r.msg}>
                      {r.msg || "-"}
                    </span>
                  </td>
                  <td>{r.reward ?? "-"}</td>
                  <td>
                    <span
                      className={`verification-badge ${getBadgeClass(r.type)}`}
                    >
                      {getBadgeClass(r.type) === "success"
                        ? "✓ "
                        : getBadgeClass(r.type) === "failed"
                          ? "✕ "
                          : ""}
                      {r.type || "-"}
                    </span>
                  </td>
                  <td>{r.modelno ?? "-"}</td>
                  <td>
                    <Button
                      type="primary"
                      size="small"
                      disabled={r.iswarranty !== "0"}
                      onClick={() =>
                        navigate("/register-warranty", {
                          state: { verifiedProduct: r },
                        })
                      }
                    >
                      Register
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="no-data">
                  <div className="no-data-icon">📋</div>
                  No verification logs found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination-container">
          <div className="pagination-info">
            <span>Items per page:</span>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
            >
              {[5, 10, 20, 50].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <span>
              Showing {filtered.length > 0 ? startIndex + 1 : 0}-
              {Math.min(startIndex + pageSize, totalItems)} of {totalItems}
            </span>
          </div>
          <div className="page-buttons">
            <button
              className="page-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <span className="page-count">
              {page} / {totalPages || 1}
            </span>
            <button
              className="page-btn"
              disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationList;
